/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc FastChatメッセージ関連ユーティリティ
 *
 * @author genka
 * @copyright Copyright 2019 TechMatrix Corporation, Inc. All rights reserved.
 */

import MessageInfoConst from '@/constants/MessageInfoConst'

export default new class {
  /**
   * メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）を取得します。
   *
   * @param {Object} messageInfo
   * @return {String} メッセージ内容部分に適用するClass（自分のメッセージor他人のメッセージ）
   */
  messageDistributionClass(messageInfo) {
    if (messageInfo.clientSystemMessage) {
      return 'client-system-message'
    }
    if (messageInfo.distributionType === MessageInfoConst.DISTRIBUTION_TYPE_FC_TO_FH) {
      return 'my-message'
    }
    return 'other-message'
  }
}()



// WEBPACK FOOTER //
// ./src/utils/FcMessageUtil.js